import React, { useState } from 'react';
import { Tabs } from './bpm';
import './StockScreener.css';

const StockScreener = ({ onLogoClick = null }) => {
  const [activeTab, setActiveTab] = useState(0);

  const tabs = [
    {
      label: 'Recherche',
      content: (
        <div className="stockscreener-tab-content">
          <p>Recherche de titres</p>
        </div>
      )
    },
    {
      label: 'Filtres',
      content: (
        <div className="stockscreener-tab-content">
          <p>Filtres de sélection</p>
        </div>
      )
    },
    {
      label: 'Résultats',
      content: (
        <div className="stockscreener-tab-content">
          <p>Résultats de la recherche</p>
        </div>
      )
    }
  ];

  return (
    <div className="stockscreener-page">
      <Tabs 
        tabs={tabs}
        defaultTab={activeTab}
        onChange={setActiveTab}
      />
    </div>
  );
};

export default StockScreener;














